import type { ReactNode } from 'react'

import { Chip } from '@/src/elements/chip'
import type { TChipProps } from '@/src/elements/chip/chip.types'
import { ICON } from '@/src/general/enums/icons'
import type { TDateArg } from '@/src/general/primitives/dates/date.types'
import { getDiffInDays } from '@/src/general/primitives/dates/dayjs'
import { useTranslate } from '@/src/lang/useTranslate'

type TCommunityNbDaysChipProps = {
  community: Record<'fromDate' | 'toDate', TDateArg | null>
  className?: string
  fontWeight?: TChipProps['fontWeight']
}

export const CommunityNbDaysChip = ({
  className,
  fontWeight = 'normal',
  community: { fromDate, toDate },
}: TCommunityNbDaysChipProps): ReactNode => {
  const { t } = useTranslate()

  if (!fromDate || !toDate) return null

  return (
    <Chip
      text={t('word.days', { count: getDiffInDays(fromDate, toDate) + 1 })}
      iconName={ICON.PATH}
      colors="default"
      fontWeight={fontWeight}
      variant="flat"
      className={className}
    />
  )
}
